export const AdminFormErrorMessage = {
  variants: {
    adminFormErrorMessage: {
      textStyle: "adminMeta",
      color: "utility.error",
    },
  },
};
